export enum AddressType {
  PickUp = "PickUp",
  CustomerAddress = "CustomerAddress",
  WalkIn = "WalkIn",
}
